module.exports = __webpack_public_path__ + "static/img/4_1_7.35579f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_7.png
// module id = ov4B
// module chunks = 1